import { BaseFilterComponent } from './types';
import { Filter } from '../../types';
import { TextEntryFilterOption } from '../options/types';
import { TextField } from '@lifeomic/chroma-react/components/TextField';
import { useIntl } from 'react-intl';
import * as React from 'react';

interface CSVTextEntryProps
  extends TextEntryFilterOption,
    BaseFilterComponent {}

export const CSVTextEntry: React.FC<CSVTextEntryProps> = ({
  injectedProps: { searchKey, textEntryOption },
  onFilterAdd,
  origin,
}) => {
  const { formatMessage } = useIntl();

  const [textValue, setTextValue] = React.useState<string>('');

  const handleTextFieldChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setTextValue(e.target.value);
  };

  const handleKeyPress = (e: React.KeyboardEvent<HTMLInputElement>) => {
    if (!textValue || textValue?.trim?.()?.length === 0) {
      return;
    }

    if (e.key !== 'Enter') {
      return;
    }

    const splitValues = textValue
      ?.split(',')
      .map(_ => _.trim())
      .filter(Boolean);

    if (onFilterAdd) {
      const results: Array<Filter> = splitValues.reduce((acc, value) => {
        const option: Filter = {
          // @ts-expect-error This directive was added as part of a bulk-change to enable strictNullChecks.
          id: `${textEntryOption.id}+${value.toLowerCase()}`,
          // @ts-expect-error This directive was added as part of a bulk-change to enable strictNullChecks.
          origin,
          // @ts-expect-error This directive was added as part of a bulk-change to enable strictNullChecks.
          searchKey,
          searchValue: value,
        };

        // @ts-expect-error This directive was added as part of a bulk-change to enable strictNullChecks.
        acc.push(option);
        return acc;
      }, []);

      onFilterAdd(results);
    }

    setTextValue('');
  };

  return (
    <TextField
      // @ts-expect-error This directive was added as part of a bulk-change to enable strictNullChecks.
      placeholder={formatMessage(textEntryOption.placeholderIntlLabel)}
      // @ts-expect-error This directive was added as part of a bulk-change to enable strictNullChecks.
      aria-label={formatMessage(textEntryOption.placeholderIntlLabel)}
      value={textValue}
      onChange={handleTextFieldChange}
      onKeyPress={handleKeyPress}
      fullWidth
    />
  );
};
